export const FP_LOGIN = '/login'
export const FP_HOME = '/home'
export const FP_SUPPORT_EMAIL = 'carrier-app-support@transfix.io'
export const FP_RATECON_EMAIL = 'ratecons@transfix.io'
export const FP_FAQ_URL = 'https://support.transfix.io/en/collections/2980031-transfix-fms'
export const FP_FAQ_URL_DRIVER_LED_STATUS =
  'https://support.transfix.io/en/articles/4765700-driver-led-status-updates'
export const CONTACT_PHONE = '+1(917) 444-9105'
export const FP_SUPPORT_PHONE = '646-844-2200'
export const FP_SUPPORT_PHONE_HOURS = 'Available Mon-Fri 9am-5pm EST'
export const FP_STATUS_PAGE_URL = 'https://status.transfix.io/'
